import(/* webpackMode: "eager" */ "/app/hub/src/app/iframe/[accountId]/folder/error.tsx");
